import React from 'react';
import { FaChartPie } from 'react-icons/fa';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { formatCurrency, getCategoryColor } from '../../utils/analyticsHelpers';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div className="custom-tooltip">
        <p className="tooltip-label">{data.category}</p>
        <p className="tooltip-value" style={{ color: payload[0].payload.fill }}>
          {formatCurrency(data.value)} ({data.percentage}%)
        </p>
        <p className="tooltip-info">{data.count} transactions</p>
      </div>
    );
  }
  return null;
};

// category distribution chart 
const CategoryPieChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="chart-empty-state">
        <p><FaChartPie /> No category data available</p>
      </div>
    );
  }

  // Calculate percentages and add colors
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const chartData = data.map((item, index) => ({
    ...item,
    name: item.category,      // show names instead of numbers (can remove this)
    percentage: total > 0 ? ((item.value / total) * 100).toFixed(1) : 0,
    fill: getCategoryColor(index)
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ category, percentage }) => `${category} (${percentage}%)`}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.fill}/>
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
        <Legend 
          verticalAlign="bottom" 
          height={36}
          wrapperStyle={{ fontSize: '12px' }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default CategoryPieChart;
